export default "__VITE_ASSET__ByKIVbBd__"